export default {"src":"/_next/static/media/CAMS.4427962b.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};